import React from 'react';

export class ValidatedIcon extends React.PureComponent {
  render() {
    return (
      <svg width="40" height="55.864" viewBox="0 0 10.583333 14.780683" {...this.props}>
        <g transform="matrix(1.0515692,0,0,1,1.7035033e-4,-1.5879095e-4)">
          <path
            style={{ mixBlendMode: 'multiply', strokeWidth: 0.264583 }}
            fill="currentColor"
            d="M 2.5159191,9.3913254 C 1.0118021,8.5212389 -1.6193515e-4,6.8949856 -1.6193515e-4,5.0323806 c 0,-2.779179 2.25298203515,-5.03216199544 5.03216003515,-5.03216199544 2.779181,0 5.0321639,2.25298299544 5.0321639,5.03216199544 0,1.862605 -1.0119679,3.4888583 -2.5160819,4.3589448 V 14.36075 c 0,0.32491 -0.353592,0.526448 -0.63313,0.360806 l -1.669169,-0.989155 c -0.131841,-0.07808 -0.295722,-0.07808 -0.427564,0 l -1.669169,0.989155 c -0.279537,0.165642 -0.633129,-0.03581 -0.633129,-0.360722 z m 2.516079,-1.0041702 c 1.852758,0 3.354777,-1.5020166 3.354777,-3.3547746 0,-1.852758 -1.502019,-3.354774 -3.354777,-3.354774 -1.852758,0 -3.354774,1.502016 -3.354774,3.354774 0,1.852758 1.502016,3.3547746 3.354774,3.3547746 z m 2.516082,-3.3547746 c 0,1.389548 -1.126451,2.516081 -2.516082,2.516081 -1.389631,0 -2.516079,-1.126533 -2.516079,-2.516081 0,-1.389547 1.126448,-2.516081 2.516079,-2.516081 1.389631,0 2.516082,1.126534 2.516082,2.516081 z"
          />
        </g>
      </svg>
    );
  }
}
